<template>
  <div class="neurolinx">
      <nav class="w-full py-4 px-4 md:px-8 fixed top-0 left-0 right-0 z-50 bg-gray-900 bg-opacity-80 backdrop-blur">
    <div class="max-w-7xl mx-auto flex justify-between items-center">
      <!-- Logo -->
      <div class="flex items-center">
        <span class="text-2xl font-bold text-purple-500">
          <!-- vue<span class="text-blue-400">3</span> -->
          <img src="../assets/TNT_LOGO_GOLD_02.png" style="height:60px" />
        </span>
      </div>

      <!-- Desktop Nav -->
      <div class="hidden md:flex items-center space-x-8">
        <a href="#services" class="text-gray-300 hover:text-purple-500 transition">Services</a>
        <a href="#about" class="text-gray-300 hover:text-purple-500 transition">About</a>
        <a href="#work" class="text-gray-300 hover:text-purple-500 transition">Case Studies</a>
        <a href="#contact" class="text-gray-300 hover:text-purple-500 transition">Contact</a>
        <a :href="whatsappUrl" target="_blank" class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg">Get Started</a>
      </div>

      <!-- Mobile Menu Button -->
      <div class="md:hidden">
        <button @click="isOpen = !isOpen">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Nav -->
    <div v-if="isOpen" class="md:hidden absolute top-full left-0 right-0 bg-gray-900 p-4 flex flex-col space-y-4">
      <a href="#services" class="text-gray-300 hover:text-purple-500 transition" @click="isOpen = false">Services</a>
      <a href="#about" class="text-gray-300 hover:text-purple-500 transition" @click="isOpen = false">About</a>
      <a href="#work" class="text-gray-300 hover:text-purple-500 transition" @click="isOpen = false">Our Work</a>
      <a href="#contact" class="text-gray-300 hover:text-purple-500 transition" @click="isOpen = false">Contact</a>
      <button class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg w-full">Get Started</button>
    </div>
  </nav>
 <section class="bg-gray-900 text-white py-24 px-6">
    <div class="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
      <!-- LEFT SIDE: TEXT -->
      <div class="max-w-xl space-y-6">
        <h1 class="text-4xl md:text-6xl font-extrabold leading-tight">
          Building <span class="text-gradient">smarter</span><br/>
          <span class="text-gradient">futures</span> with cutting-edge AI solutions
        </h1>
        <p class="text-gray-300">
          We transform businesses through strategic implementation of AI and emerging technologies. Partner with us to shape your digital future.
        </p>
        <div class="flex gap-4">
          <a :href="whatsappUrl" target="_blank" rel="noopener"
            class="bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-6 py-3 rounded-lg flex items-center gap-2">
            Book a Consultation →
          </a>

          <a class="border border-purple-500 px-6 py-3 rounded-lg" href="#work">
            View Case Studies
          </a>
        </div>
      </div>

      <!-- RIGHT SIDE: NODES DIAGRAM -->
      <div class="relative w-full lg:w-1/2 h-[400px]">
      <img src="../assets/thirdImage.jpg">
        <!-- <div class="absolute top-4 left-4 bg-gray-800 rounded-lg p-4 text-center shadow-md">
          <div class="w-6 h-6 bg-purple-500 rounded-full mx-auto mb-2"></div>
          <p class="text-sm">Input Data</p>
        </div>

        <div class="absolute top-32 left-48 bg-gray-800 rounded-lg p-4 text-center shadow-md">
          <div class="w-6 h-6 bg-indigo-500 rounded-lg mx-auto mb-2"></div>
          <p class="text-sm">AI Processing</p>
        </div>

        <div class="absolute top-4 right-4 bg-gray-800 rounded-lg p-4 text-center shadow-md">
          <div class="w-6 h-6 bg-teal-500 rounded-full mx-auto mb-2"></div>
          <p class="text-sm">Output</p>
        </div>

        <div class="absolute bottom-10 left-24 bg-gray-800 rounded-lg p-4 text-center shadow-md">
          <div class="w-6 h-6 bg-gradient-to-r from-purple-500 to-indigo-500 transform rotate-45 mx-auto mb-2"></div>
          <p class="text-sm">Feedback Loop</p>
        </div>

        <div class="absolute bottom-20 right-24 bg-gray-800 rounded-lg p-4 text-center shadow-md">
          <div class="w-6 h-6 bg-teal-500 clip-polygon mx-auto mb-2"></div>
          <p class="text-sm">Results Dashboard</p>
        </div>

        <div class="absolute w-32 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 top-12 left-20 transform rotate-12"></div>
        <div class="absolute w-40 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 top-36 left-28 transform -rotate-12"></div>
        <div class="absolute w-32 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 bottom-20 left-32 transform rotate-12"></div> -->
      </div>
    </div>
  </section>
  <section id="services" class="py-24 px-4 md:px-8 bg-gray-900 relative">
    <div class="absolute inset-0 bg-node-pattern opacity-30"></div>
    <div class="max-w-7xl mx-auto space-y-12 relative z-10">
      <div class="text-center space-y-4 max-w-3xl mx-auto">
        <p class="text-purple-500 font-semibold uppercase tracking-wide">Our Expertise</p>
        <h2 class="text-3xl md:text-4xl font-bold text-white">Comprehensive AI & Technology Services</h2>
        <p class="text-gray-300 text-lg">
          From concept to deployment, we provide end-to-end solutions tailored to your unique challenges.
        </p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div 
          v-for="(service, index) in services" 
          :key="index" 
          class="bg-gray-800 rounded-lg p-6 transition-all duration-300 hover:shadow-md hover:-translate-y-1 hover:bg-white/10"
        >
          <div class="h-12 w-12 rounded-lg bg-purple-500/20 flex items-center justify-center mb-4">
            <component :is="service.icon" class="h-6 w-6 text-purple-500" />
          </div>
          <h3 class="text-xl text-white mb-2">{{ service.title }}</h3>
          <p class="text-gray-400">{{ service.description }}</p>
        </div>
      </div>
    </div>
  </section>
  <section id="about" class="py-24 px-4 md:px-8 bg-gray-800">
    <div class="max-w-7xl mx-auto">
      <div class="flex flex-col lg:flex-row items-center gap-12">
        <!-- Left side -->
        <div class="w-full lg:w-1/2 space-y-8">
          <p class="text-purple-500 font-semibold uppercase tracking-wide">Why Choose The Network Tap</p>
          <h2 class="text-3xl md:text-4xl font-bold leading-tight text-white">
            We merge innovation with expertise to drive your success
          </h2>
          <p class="text-gray-300">
            At The Network Tap, we understand that implementing AI isn't just about technology—it's about transformation. Our multidisciplinary team brings together technical expertise and industry knowledge to deliver solutions that create real, measurable impact.
          </p>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div v-for="(point, index) in keyPoints" :key="index" class="flex items-start">
              <div class="mt-1 mr-2 h-5 w-5 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
                <Check class="h-3 w-3 text-purple-500" />
              </div>
              <p class="text-gray-300">{{ point }}</p>
            </div>
          </div>
        </div>

        <!-- Right side -->
        <div class="w-full lg:w-1/2 relative">
          <div class="absolute -bottom-6 -left-6 w-48 h-48 rounded-lg bg-gradient-to-r from-purple-500/20 to-blue-500/20 z-0 blur-lg"></div>
          <div class="relative z-10 rounded-lg overflow-hidden bg-gray-700 p-8">
            <div class="workflow-diagram">
              <img src="../assets/WorkflowMainImage.png">
            </div>
            </div>
        </div>
          <!-- <div class="absolute -bottom-6 -left-6 w-48 h-48 rounded-lg bg-gradient-to-r from-purple-500/20 to-blue-500/20 z-0 blur-lg"></div>

          <div class="relative z-10 rounded-lg overflow-hidden bg-gray-700 p-8">
            <div class="workflow-diagram">
              
              <div class="flex items-center justify-between mb-10">
                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-purple-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-purple-500"></div>
                  </div>
                  <p class="text-xs">Problem Analysis</p>
                </div>

                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-blue-500"></div>
                  </div>
                  <p class="text-xs">Solution Design</p>
                </div>

                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-teal-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-teal-500"></div>
                  </div>
                  <p class="text-xs">Implementation</p>
                </div>
              </div>

              <div class="flex justify-center mb-10">
                <div class="h-20 w-1 bg-gradient-to-b from-purple-500 to-blue-500"></div>
              </div>

              <div class="flex items-center justify-between">
                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-purple-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-purple-500"></div>
                  </div>
                  <p class="text-xs">Continuous Support</p>
                </div>

                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-blue-500"></div>
                  </div>
                  <p class="text-xs">Monitoring</p>
                </div>

                <div class="w-[120px] p-3 text-center text-white">
                  <div class="h-12 w-12 rounded-full bg-teal-500/20 flex items-center justify-center mb-2 mx-auto">
                    <div class="h-6 w-6 rounded-full bg-teal-500"></div>
                  </div>
                  <p class="text-xs">Optimization</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
 <!-- <section class="py-20 px-4 md:px-8 bg-gradient-to-r from-gray-900 to-gray-800 relative overflow-hidden">

    <div class="absolute inset-0 z-0">
      <div class="absolute top-0 left-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>
      <div class="absolute bottom-0 right-0 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl"></div>
    </div>

    <div class="max-w-7xl mx-auto relative z-10">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div 
          v-for="(stat, index) in stats" 
          :key="index" 
          class="bg-gray-800 bg-opacity-60 backdrop-blur rounded-lg p-6 flex flex-col items-center justify-center text-center"
        >
          <p class="text-4xl md:text-5xl font-bold text-gradient mb-2">{{ stat.value }}</p>
          <p class="text-gray-300">{{ stat.label }}</p>
        </div>
      </div>
    </div>
  </section> -->
  <section id="work" class="py-24 px-4 md:px-8 bg-gray-800 relative overflow-hidden">
    <!-- Connection lines background -->
    <div class="absolute inset-0">
      <div class="absolute top-[10%] left-[20%] h-[60%] w-px bg-gradient-to-b from-transparent via-purple-500/30 to-transparent"></div>
      <div class="absolute top-[30%] right-[25%] h-[40%] w-px bg-gradient-to-b from-transparent via-blue-500/30 to-transparent"></div>
      <div class="absolute top-[40%] left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-500/20 to-transparent"></div>
      <div class="absolute top-[70%] left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-500/20 to-transparent"></div>

      <!-- Node points -->
      <div class="absolute top-[40%] left-[20%] h-3 w-3 rounded-full bg-purple-500/50 shadow-lg"></div>
      <div class="absolute top-[30%] right-[25%] h-3 w-3 rounded-full bg-blue-500/50 shadow-lg"></div>
      <div class="absolute top-[40%] left-[50%] h-3 w-3 rounded-full bg-teal-500/50 shadow-lg"></div>
      <div class="absolute top-[70%] left-[35%] h-3 w-3 rounded-full bg-purple-500/50 shadow-lg"></div>
    </div>

    <div class="max-w-7xl mx-auto space-y-12 relative z-10">
      <div class="text-center space-y-4 max-w-3xl mx-auto">
        <p class="text-purple-500 font-semibold uppercase tracking-wide">Our Projects</p>
        <h2 class="text-3xl md:text-4xl font-bold text-white">Transformative Solutions in Action</h2>
        <p class="text-gray-300 text-lg">
          Explore our portfolio of successful AI implementations and workflow solutions that deliver measurable impact.
        </p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(project, index) in projects"
          :key="index"
          class="group bg-gray-700 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
        >
          <div class="aspect-video w-full overflow-hidden">
            <img
              :src="project.image"
              :alt="project.title"
              class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div class="p-6 space-y-4">
            <div class="flex flex-wrap gap-2">
              <span
                v-for="(category, catIndex) in project.categories"
                :key="catIndex"
                class="px-2 py-1 rounded bg-white/10 text-white text-sm"
              >
                {{ category }}
              </span>
            </div>
            <h3 class="text-xl font-semibold text-white" style="">{{ project.title }}</h3>
            <p class="text-gray-300">{{ project.description }}</p>
            <a :href="project.link" class="inline-flex items-center text-purple-500 hover:text-blue-500 transition-colors font-medium">
              View Case Study
              <svg class="ml-2 h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m0 0l-6-6m6 6l-6 6" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
    <section id="contact" class="py-24 px-4 md:px-8 bg-gray-900">
    <div class="max-w-7xl mx-auto">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <!-- Left side -->
        <div class="space-y-8">
          <div>
            <p class="text-purple-500 font-semibold uppercase tracking-wide">Get In Touch</p>
            <h2 class="text-3xl md:text-4xl font-bold mt-2" style="color:white">Ready to transform your business?</h2>
            <p class="text-gray-300 text-lg mt-4">
              Contact us today to start a conversation about how our AI solutions can drive your business forward.
            </p>
          </div>

          <div class="space-y-6">
            <div class="flex items-start">
              <div class="mt-1 mr-3 h-10 w-10 rounded-full bg-purple-500/10 flex items-center justify-center flex-shrink-0">
                <MailIcon class="h-5 w-5 text-purple-500" />
              </div>
              <div>
                <h3 class="text-lg font-medium" style="color:white">Email Us</h3>
                <p class="text-gray-300 mt-1">thenetworktap@gmail.com</p>
              </div>
            </div>

            <!-- <div class="flex items-start">
              <div class="mt-1 mr-3 h-10 w-10 rounded-full bg-purple-500/10 flex items-center justify-center flex-shrink-0">
                <PhoneIcon class="h-5 w-5 text-purple-500" />
              </div>
              <div>
                <h3 class="text-lg font-medium" style="color:white">Call Us</h3>
                <p class="text-gray-300 mt-1"></p>
              </div>
            </div> -->

            <!-- <div class="flex items-start">
              <div class="mt-1 mr-3 h-10 w-10 rounded-full bg-purple-500/10 flex items-center justify-center flex-shrink-0">
                <MapPinIcon class="h-5 w-5 text-purple-500" />
              </div>
              <div>
                <h3 class="text-lg font-medium" style="color:white">Visit Us</h3>
                <p class="text-gray-300 mt-1">123 Tech Avenue, Innovation District<br />San Francisco, CA 94105</p>
              </div>
            </div> -->
          </div>
        </div>

        <!-- Right side -->
        <div class="bg-gray-800 bg-opacity-60 backdrop-blur rounded-lg p-8 shadow-lg flex flex-col items-center justify-center">
          <h3 class="text-2xl font-bold mb-6 text-center" style="color:white">Start chatting with us now</h3>
          <p class="text-gray-300 mb-8 text-center max-w-md">
            Get an instant response from our team through WhatsApp. We're ready to answer your questions and discuss your AI project needs.
          </p>

          <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer" class="w-full sm:w-auto">
            <button class="w-full text-lg py-6 px-8 bg-green-500 hover:bg-green-600 flex items-center justify-center gap-3 rounded-lg">
              <MessageSquareIcon class="h-6 w-6" />
              Chat on WhatsApp
            </button>
          </a>

          <p class="text-xs text-gray-400 text-center mt-8">
            By contacting us, you agree to our privacy policy.
          </p>
        </div>
      </div>
    </div>
  </section>
  </div>

</template>

<script>
import { Brain, Database, Code, BarChart, Globe, Shield,Check,Mail, Phone, MapPin, MessageSquare,Workflow,Cpu } from 'lucide-vue-next';

export default {
  name: 'TNTAIAgentLandingPage',
  components: {
    Brain,
    Database,
    Code,
    BarChart,
    Globe,
    Shield,
    Check,
    MailIcon: Mail,
    PhoneIcon: Phone,
    MapPinIcon: MapPin,
    MessageSquareIcon: MessageSquare,
    Workflow,
    Cpu
  },
   data() {
    return {
      isOpen :true,
      isMobile: false, 
      services: [
        {
          icon: 'Brain',
          title: 'AI Development',
          description:
            'Custom artificial intelligence solutions designed to transform your business operations and decision-making.',
        },
        {
          icon: 'Database',
          title: 'System Design',
          description:
            'We help you solutionize based on your unique needs, so you can focus on what really matters.',
        },
        {
          icon: 'Code',
          title: 'Software Engineering',
          description:
            'Full-stack development services built on modern frameworks with scalability and performance in mind.',
        },
        {
          icon: 'BarChart',
          title: 'Data Analytics',
          description:
            'Turn raw data into strategic business intelligence with our comprehensive analytics solutions.',
        },
        {
          icon: 'Cpu',
          title: 'Tech Advisory',
          description:
            'Get expert advice to navigate complex technology choices with confidence.',
        },
        {
          icon: 'Workflow',
          title: 'Automation & Workflow',
          description:
            'Streamline your business with smart automation that frees up time and resources.',
        },
      ],
      keyPoints: [
        "From strategy to execution, we cover all the tech you need to grow fast and stay ahead.",
        "State-of-the-art AI solutions that drive real business results",
        "With data analytics, tech advisory, and automation, we help you work smarter, not harder.",
        "We bring together AI development, system design, and software engineering to power your business forward.",
        "Dedicated support and transparent project management",
        "Continuous research and development to stay ahead of trends"
      ],
      stats:[
              {
                value: "98%",
                label: "Client satisfaction rate"
              },
              {
                value: "40+",
                label: "Successful AI implementations"
              },
              {
                value: "67%",
                label: "Average efficiency improvement"
              },
              {
                value: "12+",
                label: "Industries served"
              }
            ],
    projects: [
            {
              title: "AI Agents for Business: The Future of Automation",
              description: "AI agents are transforming business operations by automating tasks across departments like IT, HR, and customer service. They enhance efficiency, reduce costs, and improve employee and customer experiences.",
              image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=80&w=1000",
              categories: ["AI", "Workflow", "Automation"],
              link:"https://aisera.com/blog/ai-agents-for-business/"
            },
            {
              title: "AI agents: from co-pilot to autopilot\n",
              description: "AI agents are transitioning from simple assistants to autonomous systems capable of executing complex tasks with minimal human intervention. This evolution is enhancing efficiency and allowing human workers to focus on more creative roles",
              image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&q=80&w=1000", 
              categories: ["AI", "Workflow", "Automation"],
              link:"https://www.ft.com/content/3e862e23-6e2c-4670-a68c-e204379fe01f"
            },
            {
              title: "EY's AI Agents Enhance Workforce Productivity",
              description: "Y's CEO, Janet Truncale, believes AI will double the firm's size without reducing headcount. Their EY.ai Agentic Platform deploys 150 AI agents assisting 80,000 tax professionals, automating tasks like data collection and compliance, allowing employees to focus on complex work.",
              image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=1000",
              categories: ["AI", "Workflow", "Automation"],
              link:"https://www.ft.com/content/3e862e23-6e2c-4670-a68c-e204379fe01f"
            }
          ],
          whatsappUrl: 'https://wa.me/6594768087',
    }
    
  },
  methods: {
    checkScreenSize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768; // Set breakpoint for mobile
      if (this.isMobile && !wasMobile) {
        this.isOpen = false;
      }
    },
  },
    async mounted() {
      this.checkScreenSize(); // Check on page load
      window.addEventListener("resize", this.checkScreenSize);
      window.addEventListener("touchmove", (event) => {
        if (this.isMobile) {
          event.stopPropagation();
        }
      });
    }
};
</script>

<style scoped>
.text-gradient {
  background: linear-gradient(to right, #8b5cf6, #6366f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
